module Meevo.Plugins.Register {
    export class RebookItem {
        appointmentServiceId: string;
        service: any;
        employee: any;
        client:any;
        serviceDate: string;
    }

    export class RebookService {
        constructor(private dataService,
            private modalService: Meevo.Components.Modal.IModalService,
        private $q) { }

        showRebookCandidates(items: RebookItem[], fromRegister, candidates: any = undefined) {
            let defer = this.$q.defer();
            if (candidates && candidates.length > 0) {
                this.showModal(items, candidates, fromRegister).then(() => {
                    return defer.resolve(candidates);
                });
            }
            else {
                this.getRebookCandidates(items).then(candidates => {
                    if (candidates.length > 0) {
                        this.showModal(items, candidates, fromRegister).then(() => {
                            return defer.resolve(candidates);
                        });
                    }
                    else {
                        return defer.resolve(candidates);
                    }
                });
            }
            return defer.promise;    
        }

        getRebookCandidates(items: RebookItem[]) {
            let defer = this.$q.defer();

            if (items.length == 0) {
                defer.resolve([]);
            }

            let criteria: any[] = [];
            items.forEach((item: RebookItem) => {
                let existingCriterion = _(criteria).findWhere({
                    clientId: item.client.id,
                    serviceId: item.service.id
                });

                let newServiceDate = moment(item.serviceDate).add(1, "days").startOf("day").toDate();
                if (!existingCriterion) {
                    criteria.push({
                        clientId: item.client.id,
                        serviceId: item.service.id,
                        startDate: newServiceDate,
                        employeeId: angular.isDefined(item.employee) ? item.employee.id : undefined,
                        appointmentServiceId: item.appointmentServiceId
                    }
                    );
                }
                else if (newServiceDate > existingCriterion.startDate) {
                    existingCriterion.stateDate = newServiceDate;
                }
            });

            if (criteria.length > 0) {
                this.dataService.customMethodData("/api/RebookCandidate/List", "post",
                        {
                            criteria: criteria
                        })
                    .then(response => {
                        defer.resolve(response.data);
                    });
            } else {
                defer.resolve([]);
            }
            return defer.promise;
        }

        private showModal(items, rebookCandidates, fromRegister): angular.IPromise<any> {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/rebookModal.template.html",
                controller: "meevo.plugins.register.RebookModalController",
                controllerAs: "vm",
                bindToController: true,
                //clickOutsideToClose: true,
                multiple: true,
                locals: {
                    items: items,
                    rebookCandidatesInitial: rebookCandidates,
                    fromRegister: fromRegister
                }
            }

            return this.modalService.showCustom(options);
        }

        static factory(): Function {
            let svc = (dataService, modalService,$q) => {
                return new RebookService(dataService, modalService,$q);
            }

            svc.$inject = ['meevo.components.common.DataService',
                'meevo.components.modal.ModalService',
                '$q'
            ];
            return svc;
        }
    }

    angular.module("meevo.plugins.register")
        .service("meevo.plugins.register.RebookService", RebookService.factory());
}